import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import { useRoute, useRouter } from 'vue-router/composables';
import { computed, ref } from 'vue';
import { CookieClaimManager, CookieClaimOptions } from '@/services/CookieClaimManager';
import AppConfig from '@/configLoader';
//firebase
import { initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';
import { bootstrap, optIn, optOut } from 'vue-gtag';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CookiePreferences',
    setup(__props) {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const cookieClaimManager = new CookieClaimManager();
        const essentialCookiesSwitch = ref(true);
        const analyticsCookiesSwitch = ref(cookieClaimManager.hasClaim(CookieClaimOptions.ACCEPT_ANALYTICS_COOKIES));
        const essentialCookiesList = [
            {
                name: 'apiUserFullName',
                provider: 'LogHub',
                description: t('cookies.custom_modal.essential.descriptions.fullName'),
                lifetime: t('cookies.custom_modal.lifetime.never'),
                type: t('cookies.custom_modal.type.1st')
            },
            {
                name: 'apiUserRole',
                provider: 'LogHub',
                description: t('cookies.custom_modal.essential.descriptions.role'),
                lifetime: t('cookies.custom_modal.lifetime.never'),
                type: t('cookies.custom_modal.type.1st')
            },
            {
                name: 'sessionPassword',
                provider: 'LogHub',
                description: t('cookies.custom_modal.essential.descriptions.pswd'),
                lifetime: t('cookies.custom_modal.lifetime.never'),
                type: t('cookies.custom_modal.type.1st')
            },
            {
                name: 'username',
                provider: 'LogHub',
                description: t('cookies.custom_modal.essential.descriptions.username'),
                lifetime: t('cookies.custom_modal.lifetime.never'),
                type: t('cookies.custom_modal.type.1st')
            }
        ];
        const analyticsCookiesList = [
            {
                name: '_ga',
                provider: 'Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.ga'),
                lifetime: t('cookies.custom_modal.lifetime.2y'),
                type: t('cookies.custom_modal.type.3rd')
            },
            {
                name: '_gid',
                provider: 'Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.ga'),
                lifetime: t('cookies.custom_modal.lifetime.1d'),
                type: t('cookies.custom_modal.type.3rd')
            },
            {
                name: '_gat_gtag_ APP_ID',
                provider: 'Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.ga'),
                lifetime: t('cookies.custom_modal.lifetime.1m'),
                type: t('cookies.custom_modal.type.3rd')
            },
            {
                name: 'SIDCC',
                provider: 'Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.SIDCC'),
                lifetime: t('cookies.custom_modal.lifetime.6m'),
                type: t('cookies.custom_modal.type.3rd')
            },
            {
                name: 'collect',
                provider: 'Pixel / Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.collect'),
                lifetime: t('cookies.custom_modal.lifetime.session'),
                type: t('cookies.custom_modal.type.3rd')
            },
            {
                name: '1P_JAR',
                provider: 'Google Analytics',
                description: t('cookies.custom_modal.analytics.descriptions.1p'),
                lifetime: t('cookies.custom_modal.lifetime.30d'),
                type: t('cookies.custom_modal.type.3rd')
            }
        ];
        const hasAnalyticsAllowedInConfig = computed(() => AppConfig.getConfig().google_analytics.allowed == true);
        const hasFirebaseAllowed = computed(() => AppConfig.getConfig().firebase.allowed == true);
        const firebaseConfiguration = computed(() => AppConfig.getConfig().firebase.config);
        function savePreferences() {
            cookieClaimManager.addLocalClaim(CookieClaimOptions.ACCEPT_ESSENTIAL_COOKIES);
            if (analyticsCookiesSwitch.value) {
                cookieClaimManager.addLocalClaim(CookieClaimOptions.ACCEPT_ANALYTICS_COOKIES);
                if (hasAnalyticsAllowedInConfig.value == true) {
                    enablePlugin();
                }
                if (hasFirebaseAllowed.value) {
                    // Initialize Firebase
                    const app = initializeApp(firebaseConfiguration.value);
                    // Initialize Performance Monitoring and get a reference to the service
                    getPerformance(app);
                }
            }
            else {
                if (hasAnalyticsAllowedInConfig.value == true) {
                    optOut();
                }
                if (hasFirebaseAllowed.value) {
                    //turnoff
                    const app = initializeApp(firebaseConfiguration.value);
                    // Initialize Performance Monitoring and get a reference to the service
                    const perf = getPerformance(app);
                    perf.instrumentationEnabled = false;
                    perf.dataCollectionEnabled = false;
                }
            }
            cookieClaimManager.commit();
        }
        function enablePlugin() {
            bootstrap().then(() => {
                optIn();
            });
        }
        function openPolicy() {
            router
                .push({
                name: 'privacyPolicy',
                params: { lang: route.params.lang }
            })
                .catch((err) => err);
        }
        return { __sfc: true, t, route, router, cookieClaimManager, essentialCookiesSwitch, analyticsCookiesSwitch, essentialCookiesList, analyticsCookiesList, hasAnalyticsAllowedInConfig, hasFirebaseAllowed, firebaseConfiguration, savePreferences, enablePlugin, openPolicy };
    }
});
